import { useEffect } from "react";
import { useLocation, useNavigate, Location } from 'react-router-dom';
import { helpers } from "@shared";
import { UserIcon } from "@icons";
import { Button } from '@common';

interface LocationState {
    accounts: Array<{ idAccount: string; residentName: string }>;
}

const OnboardMultipleAccountsInfo = () => {

    const navigate = useNavigate();
    const location = useLocation() as Location<LocationState>;
    const { state: { accounts } } = location;

    const next = () => {
        helpers.navigateNext(location, navigate);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="flex flex-col w-full">
            <div className="mb-8">
                <h1 className="text-[20px] leading-[24px] md:text-[28px] md:leading-[40px] font-medium text-neutral-950 tracking-[0.2px] md:tracking-[0.28px]">
                    Resident Accounts
                </h1>
                <p className="text-sm leading-5 text-neutral-800 tracking-[0.14px] mt-1">
                    You have multiple Residents connected to your account.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 md:mb-8">
                {
                    accounts.map(a => {
                        const { idAccount, residentName } = a;
                        return (
                            <div
                                key={idAccount}
                                className="flex items-center gap-3 px-6 py-4 rounded-lg border border-neutral-100 bg-white"
                            >
                                <UserIcon className="w-6 h-6 text-neutral-700 flex-shrink-0" />
                                <span className="text-base leading-6 text-neutral-950 tracking-[0.16px]">
                                    {residentName}
                                </span>
                            </div>
                        );
                    })
                }
            </div>

            <p className="text-sm leading-5 text-neutral-800 tracking-[0.14px] mb-8">
                To complete your account setup, let’s check the Resident settings.
            </p>

            <Button
                type="button"
                variant="primary"
                size="lg"
                className="w-full"
                onClick={next}
            >
                Continue
            </Button>
        </div>
    );
};

export default OnboardMultipleAccountsInfo;
